<template>
  <div class="card card-plain">
    <div role="tab" id="headingOne" class="card-header">
      <a data-toggle="collapse"
         data-parent="#accordion"
         :href="`#${itemId}`"
         @click.prevent="activate"
         :aria-expanded="active"
         :aria-controls="`content-${itemId}`">
        <slot name="pretitle">
          <span class='collapse-pre'>
          </span>
        </slot>
        <slot name="title">
          <span class='collapse-title'>
          {{title}}
          </span>
        </slot>
        <slot name="post-title">
          <span class='collapse-post'>
          </span>
        </slot>
        <slot name="icon">
          <i v-if="!noIcon" style="min-width:16px" class="collapse-icon geno-default-icons arrows-1_minimal-down"></i>
        </slot>
      </a>
    </div>
    <collapse-transition :duration="animationDuration">
      <div v-show="active"
           :id="`content-${itemId}`"
           role="tabpanel"
           :aria-labelledby="title"
           class="collapsed">
        <div class="card-body">
        <slot name="run-selection">
          <span class='collapse-run'>
          </span>
        </slot>
          <slot></slot>
        </div>
      </div>
    </collapse-transition>
  </div>
</template>
<script>
  import {CollapseTransition} from 'vue2-transitions';

  export default {
    name: 'collapse-item',
    components: {
      CollapseTransition
    },
    props: {
      title: {
        type: String,
        default: ''
      },
      id: String,
      noIcon: Boolean
    },
    inject: {
      animationDuration: {
        default: 250
      },
      multipleActive: {
        default: true
      },
      addItem: {
        default: () => {}
      },
      removeItem: {
        default: () => {}
      },
      deactivateAll: {
        default: () => {}
      }
    },
    computed: {
      itemId() {
        return this.id || this.title
      }
    },
    data() {
      return {
        active: false
      }
    },
    methods: {
      activate(){
        if(!this.multipleActive){
          this.deactivateAll();
        }
        this.active = !this.active;
      }
    },
    mounted() {
      this.addItem(this);
              this.$root.$on('collapse-select', (action) => {
	      if (action === 'collapse') {
              this.active = false;
	      } else {
	      this.active = true;
	      }
              })
    },
    destroyed() {
      if (this.$el && this.$el.parentNode) {
        this.$el.parentNode.removeChild(this.$el)
      }
      this.removeItem(this)
    }
  }
</script>
<style>
</style>
